/**
 * This agent's custom surface components — the client half of the agent's
 * catalog (server half: `agent-dev-server/src/surfaces/`). Each entry maps a
 * `ComponentContract.component` name to its React realization; add one line
 * per screen the builder authors. `SurfaceRenderer` consults this before the
 * platform builtin catalog and the v1 primitives.
 *
 * `StudioFrame` and `StudioBlock` are not screens of their own: they are the
 * node types the `Studio` contract's `compose` emits, which is what lets the
 * canvas stream one finished block at a time.
 */
import type { FC } from 'react';
import type { A2uiNodeViewProps } from '@/app/lib/a2ui/catalog.tsx';
import { StudioEntry } from './StudioEntry.tsx';
import { Studio, StudioBlock, StudioFrame } from './Studio.tsx';

export const AGENT_SURFACE_COMPONENTS: Record<string, FC<A2uiNodeViewProps>> = {
  StudioEntry,
  Studio,
  StudioFrame,
  StudioBlock,
};
